<template>
  <order-management my-order ></order-management>
</template>

<script>
import OrderManagement from '@/views/Order/OrderManagement.vue';

export default {
  name: 'MyOrder',
  components: {
    OrderManagement,
  },
};
</script>
